/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import Queueadd from "../queueList/Queueadd";
import QueuepatientDetails from "./queuepatientDetails";
import TechnicianPatientDetails from "../technician/technicianPatientDetails";
import DoctorPatientDetails from "./doctorPatientDetails";
import PatientDetails from "./patientDetails";
import Accesspage from "./../../common/404";
import QueueListConfig from "./QueueListConfig";
import Operator from "../operator/Operator";
import Technician from "../technician/Technician";
import DoctorAndNurse from "../doctorAndNurse/DoctorAndNurse";
import TokenGenerator from "../token/TokenGenerator";
import Biller from "../biller/Biller";

class Queue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }

  renderbodyLayer() {
    const { slug } = this.props.match.params;
    const { menuList } = this.props;
    // console.log("data");
    // console.log(this.props);
    let obj = null;
    menuList.map((data) => {
      var subData = data.submenu.find((o) => o.route === slug);
      // console.log(subData);
      if (subData != undefined) {
        obj = subData;
      }
    });
    var page = null;
    // console.log(obj);
    if (obj !== undefined) {
      switch (slug) {
        case "add":
        case "edit":
        case "view":
          page = (
            <Queueadd {...this.props} {...this.state} menuList={menuList} />
          );
          break;
        case "queue-list":
          page = (
            <QueueListConfig
              {...this.props}
              {...this.state}
              menuList={menuList}
            />
          );
          break;
        case "token-generator":
          page = <TokenGenerator {...this.props} />;
          break;
        case "biller-view":
          page = <Biller {...this.props} />;
          break;
        case "vitals-view":
          page = (
            <DoctorAndNurse
              {...this.props}
              menuList={menuList}
              viewFor="nurse"
            />
          );
          break;
        case "operator-view":
          // page = <QueuepatientDetails {...this.props}></QueuepatientDetails>;
          page = <Operator {...this.props} />;
          break;
        case "technician-view":
          page = <TechnicianPatientDetails {...this.props} />;
          // page = <Technician {...this.props} />;

          break;
        case "doctor-view":
          page = <Biller {...this.props} />;

          break;
        default:
          let submenu = null;
          if (menuList[0]["submenu"].length !== 0) {
            submenu = menuList[0]["submenu"][0]["route"];
          }
          if (submenu !== null) {
            this.props.history.push(`/${menuList[0]["route"]}/${submenu}`);
          } else {
            this.props.history.push(`/${menuList[0]["route"]}}`);
          }
          break;
      }
    } else {
      page = <Accesspage />;
    }

    return page;
  }
  render() {
    return <div>{this.renderbodyLayer()}</div>;
  }
}

export default Queue;
